
<div class="pagination-wrapper">
  <div class="pagination-container">

    @if (!isMobile) {
      <span>Monstrando </span>
    }
    @if (!isMobile) {
      <span>{{ startPage }}</span>
    }
    @if (!isMobile) {
      <span> - </span>
    }
    @if (!isMobile) {
      <span>{{ endPage }}</span>
    }
    @if (!isMobile) {
      <span> de {{ pTotalItems }}</span>
    }
    <button class="pag-button" [disabled]="pCurrentPage === 1" (click)="changePage(pCurrentPage - 1, pPageSize)">
      <span class="po-icon po-icon-arrow-left"></span>
    </button>
    <span>Página</span>

    <po-number
      class="po-md-6 po-lg-3"
      name="thousandMaxlength"
      [p-min]="1"
      [p-max]="pTotalPages"
      p-size="'sm'"
      [ngModel]="pCurrentPage"
      (p-change-model)="changePage($event, pPageSize)">
      >
    </po-number>

    <span>de {{ pTotalPages }}</span>
    <button class="pag-button" [disabled]="pCurrentPage === pTotalPages" (click)="changePage(pCurrentPage + 1, pPageSize)">
      <span class="po-icon po-icon-arrow-right"></span>
    </button>
    @if (!isMobile) {
      <span> Resultados por página</span>
    }
    @if (!isMobile) {
      <po-select
        class="page-size-select"
        p-size="small"
        [p-options]="pageSizeOptions"
        (p-change)="changePage(1, $event)"
        [ngModel]="10"
        >
      </po-select>
    }
  </div>
</div>